/**
 * Юридические документы платформы: страница и утверждённый PDF.
 *
 * Страницы — статические файлы `public/<имя>/index.html`, которые nginx отдаёт
 * по адресу без расширения (см. `nginx.conf`). Адрес политики указан в Google
 * Play — «Контент приложения → Политика конфиденциальности» и «Безопасность
 * данных», — поэтому он обязан открываться публично, без авторизации и без
 * редиректов; остальные два документа сделаны так же, чтобы их можно было
 * читать в браузере, а не только скачивать. Все три страницы двуязычные: оба
 * утверждённых текста (ru и kk) идут на одной странице.
 *
 * PDF лежат в `public/docs` под латинскими именами: адрес не зависит от
 * кодировки, и файл скачивается под читаемым названием. Все три — двуязычная
 * редакция, совпадающая с текстом своей страницы слово в слово. Меняется
 * документ — сначала обновляется PDF, потом страница.
 *
 * Это единственный список документов в приложении: из него берут адреса ссылки
 * в интерфейсе, правило dev-сервера в `vite.config.ts` и таблица страниц в
 * тесте. Появится четвёртый документ — он добавляется сюда, и тогда же
 * перестанут сходиться `nginx.conf` и тест, которые это проверяют.
 */
interface LegalDoc {
  /** Адрес страницы; он же имя каталога в `public`. */
  readonly path: string;
  /** Утверждённый PDF, на который ведёт ссылка «Скачать PDF». */
  readonly pdf: string;
}

export const legalDocs = {
  privacy: { path: '/privacy', pdf: '/docs/moneytome-privacy-policy.pdf' },
  offer: { path: '/offer', pdf: '/docs/moneytome-user-agreement.pdf' },
  cardPayment: { path: '/card-payment', pdf: '/docs/moneytome-card-payment-terms.pdf' },
} as const satisfies Record<string, LegalDoc>;

/** Все документы списком — для правил и проверок, которым нужен перебор. */
export const legalDocList: ReadonlyArray<LegalDoc> = Object.values(legalDocs);
